import { Edit } from "@mui/icons-material";
import { Button, useMediaQuery } from "@mui/material";
import useAuth from "hooks/useAuth";
import { useTranslation } from "react-i18next";

const IndieEditButton = ({label, useAuthTests, permissionGroups, ...params}) => {
    const { t } = useTranslation();
    
    const useAuthContext = useAuthTests || useAuth;
    const { hasPermissionGroup } = useAuthContext();
    const isUpSm = useMediaQuery((theme) => theme.breakpoints.up("sm"));

    if (permissionGroups && !hasPermissionGroup(permissionGroups)) {
        return "";
    }

    return <Button startIcon={<Edit/>} variant={params.variant || "outlined"} {...params}>{isUpSm && (label ? label : t("label.button.edit"))}</Button>
}

export default IndieEditButton;